import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPanTool1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.3985 12.7514C13.1777 12.7511 13 12.5721 13 12.3514V11.6483C13 11.4272 13.1783 11.248 13.3994 11.2483C15.2332 11.2503 18.5405 11.253 20.1261 11.2539L18.1571 9.2849C17.8634 8.99123 17.8631 8.51537 18.1565 8.22205C18.4498 7.92873 18.9256 7.92901 19.2193 8.22268L22.472 11.4754C22.7612 11.7646 22.7618 12.2474 22.4743 12.5367L22.4727 12.5383L19.2238 15.7872C18.9304 16.0805 18.4546 16.0802 18.1609 15.7865C17.8672 15.4929 17.867 15.017 18.1603 14.7237L20.127 12.757C18.5409 12.7561 15.2324 12.7534 13.3985 12.7514Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.6001 11.2447C13.821 11.2448 14 11.4238 14 11.6447V12.3478C14 12.5688 13.8209 12.7478 13.5999 12.7478L3.85404 12.7462L5.82303 14.7152C6.1167 15.0089 6.11698 15.4848 5.82366 15.7781C5.53033 16.0714 5.05448 16.0711 4.7608 15.7774L1.50807 12.5247C1.21974 12.2364 1.21882 11.7522 1.50584 11.4635L1.50745 11.4619L4.75634 8.21297C5.04966 7.91965 5.52552 7.91993 5.81919 8.2136C6.11286 8.50727 6.11314 8.98313 5.81982 9.27645L3.85313 11.2431L13.6001 11.2447Z",
		fill: "currentColor"
	})]
});
export { SvgIconPanTool1 as ReactComponent };
